import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import _ from 'lodash'
import config from './firebaseRef'

firebase.initializeApp(config)

const userRef = firebase.database().ref('user')
async function checkUserProfile ({ uid, email }) {
  const snapshot = await userRef.child(uid).once('value')
  if (snapshot.val() == null) {
    userRef.child(uid).set({
      role: 'vendor',
      email
    })
  } else {
    store.dispatch('userProfile', snapshot.val())
    subscribeFirmware()
  }
}

let firmwareQuery = null
function subscribeFirmware () {
  if (firmwareQuery) firmwareQuery.off()
  // Intrihub serves only Intrising firmware regardless of the signed-in user's custom.
  firmwareQuery = firebase.database().ref('firmware').orderByChild('custom').startAt('intrising').endAt('intrising')
  firmwareQuery.on('value', (sn) => {
    const list = _.transform(sn.val(), (acc, value, key) => {
      acc.push({ '.key': key, ...value })
    }, [])
    store.dispatch('SET_FIRMWARE_LIST', list)
  })
}

function unsubscribeFirmware () {
  if (firmwareQuery) {
    firmwareQuery.off()
    firmwareQuery = null
  }
  store.dispatch('CLEAR_FIRMWARE_LIST')
}

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    checkUserProfile(user)
  } else {
    unsubscribeFirmware()
  }
  store.dispatch('user', user || {})
  store.dispatch('authed', user !== null)
})

const AUTH_STATE_AUTHING = 0
const AUTH_STATE_NOAUTH = 1
export const AUTH_STATE_AUTHED = 2
const storedState = {
  authState: AUTH_STATE_AUTHING,
  user: {},
  firmwareList: [],
  firmwareLoaded: false
}
const mutations = {
  authed (state, authed) {
    state.authState = authed ? AUTH_STATE_AUTHED : AUTH_STATE_NOAUTH
  },
  user (state, content) {
    state.user = {
      email: content.email
    }
  },
  userProfile (state, profile) {
    state.user = {
      ...state.user,
      ...profile
    }
  },
  SET_FIRMWARE_LIST (state, list) {
    state.firmwareList = list
    state.firmwareLoaded = true
  },
  CLEAR_FIRMWARE_LIST (state) {
    state.firmwareList = []
    state.firmwareLoaded = false
  }
}

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: storedState,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})

export function login (...arg) {
  return firebase.auth().signInWithEmailAndPassword(...arg)
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail)
}

export function firebaseLogout () {
  return firebase.auth().signOut()
}
export function firebaseSetPwd (newPwd) {
  return firebase.auth().currentUser.updatePassword(newPwd)
}

function delay (sec = 1) {
  if (sec > 10) return // console.log('delay cannot bigger than 10s')
  return new Promise(resolve => {
    setTimeout(resolve, sec * 1000)
  })
}

export async function getAuthState () {
  // eslint-disable-next-line
  while (storedState.authState === AUTH_STATE_AUTHING) {
    await delay(1)
    // console.log('waiting auth')
  }
  return storedState.authState === AUTH_STATE_AUTHED
}

export function getFireBase () {
  return firebase
}

export function getDb () {
  return firebase.database()
}

export function getDbTime () {
  return firebase.database.ServerValue.TIMESTAMP
}

export function getFwSwitchRef () {
  return firebase.database().ref('firmware/switch/storage')
}

export function getNetworkModelRef () {
  return firebase.database().ref('network/model')
}

export function getNetworkFamilyRef () {
  return firebase.database().ref('productFamily')
}

export function getFWPiRef () {
  return firebase.database().ref('firmware/pi/storage')
}

export function getSwitchRef () {
  return firebase.database().ref('switch/registeration')
}

export function getSwitchHistory () {
  return firebase.database().ref('switch/history')
}

export function getSmartCtrlRef () {
  return firebase.database().ref('smart-controller/registeration')
}

export function getSmartCtrlHistory () {
  return firebase.database().ref('smart-controller/history')
}

export function getSmartCtrlActRef () {
  return firebase.database().ref('smart-controller/registerationChange')
}

export function getPMIB () {
  return firebase.database().ref('privateMIB')
}

export function getNewMib () {
  return firebase.database().ref('newPrivateMib').child('versions')
}

export async function getDownload(path) {
  const url = firebase.storage().ref(path).getDownloadURL()
    .then((url) => {
      // Insert url into an <img> tag to "download"
      // console.log("getDownload", url)
      return url
    })
    .catch((error) => {
      console.log("getDownload", error)
      return ""
    })
  return url
}

export function getModelForUI (model) {
  switch (model) {
    case 'ite':
      return 'ITE'
    case 'iteHome':
      return 'ITE Home'
    case 'aspeed':
      return 'Aspeed'
  }
}

export function getCustomForUI (custom) {
  switch (custom) {
    case 'intrising':
      return 'Intrising'
    default:
      return null
  }
}

export function getCustomFromLabel (custom) {
  switch (custom) {
    case 'Intrising':
      return 'intrising'
  }
}

export function getCategoryFromLabel (label) {
  switch (label) {
    case 'A Series':
      return 'router'
    case 'B Series':
      return 'routerx'
    case 'C Series':
      return 'swix2'
    case 'E Series':
      return 'swix1'
    case 'V Series':
      return 'os5'
    case 'T Series':
      return 'os6'
  }
}

export function isSwitchCategory (category) {
  return ['router', 'routerx', 'swix2', 'swix1', 'os5', 'os6'].includes(category)
}

export function getLabelFromCategory (category) {
  switch (category) {
    case 'router': return 'A Series'
    case 'routerx': return 'B Series'
    case 'swix2': return 'C Series'
    case 'swix1': return 'E Series'
    case 'os5': return 'V Series'
    case 'os6': return 'T Series'
    case 'viewer': return 'InstaViewer'
    default: return category
  }
}

export const documentTypeOptions = [
  { label: 'QIG', value: 'qig' },
  { label: 'CLI Manual L2', value: 'cli_manual_l2' },
  { label: 'CLI Manual L3', value: 'cli_manual_l3' },
  { label: 'Upgrade Guide', value: 'upgrade_guide' },
  { label: 'Datasheet', value: 'datasheet' }
]

export const documentTypeLabelMap = {
  qig: 'QIG',
  cli_manual_l2: 'CLI Manual L2',
  cli_manual_l3: 'CLI Manual L3',
  upgrade_guide: 'Upgrade Guide',
  datasheet: 'Datasheet'
}

export const documentTypeLabelClass = {
  qig: 'label-primary',
  cli_manual_l2: 'label-info',
  cli_manual_l3: 'label-info',
  upgrade_guide: 'label-warning',
  datasheet: 'label-default'
}

export const documentTypeColor = {
  qig: '#e67e22',
  cli_manual_l2: '#5bc0de',
  cli_manual_l3: '#2e86c1',
  upgrade_guide: '#9b59b6',
  datasheet: '#1abc9c'
}

export const filterOptions = {
  category: [
    { label: 'A Series', value: 'router' },
    { label: 'B Series', value: 'routerx' },
    { label: 'C Series', value: 'swix2' },
    { label: 'E Series', value: 'swix1' },
    { label: 'V Series', value: 'os5' },
    { label: 'T Series', value: 'os6' },
  ],
  custom: [
    { label: 'Intrising', value: 'intrising' },
  ],
  status: {
    firmware: [
      { label: 'Release', value: 'release' },
      { label: 'Develop', value: 'develop' }
    ],
    product: [
      { label: 'Production', value: 'production' },
      { label: 'Develop', value: 'develop' },
      { label: 'Porting', value: 'porting' }
    ]
  }
}

export const snmpOidDocOpts = {
  lantech: 'https://drive.google.com/open?id=0ByPOatSTzklcb1plUFZDWUEyazg'
}

export function resolveDownloadUrl (url) {
  if (!url) return url
  // https://drive.google.com/file/d/FILE_ID/view
  const fileMatch = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)
  if (fileMatch) return `https://drive.google.com/uc?export=download&id=${fileMatch[1]}`
  // https://drive.google.com/open?id=FILE_ID
  const openMatch = url.match(/drive\.google\.com\/open\?id=([a-zA-Z0-9_-]+)/)
  if (openMatch) return `https://drive.google.com/uc?export=download&id=${openMatch[1]}`
  return url
}

export const naturalSorting = (data, key, option = 'asc') => {
  return option === 'asc'
    ? data.slice().sort((a, b) => a[key].replace(' ', '').localeCompare(b[key].replace(' ', ''), undefined, { numeric: true }))
    : data.slice().sort((a, b) => b[key].replace(' ', '').localeCompare(a[key].replace(' ', ''), undefined, { numeric: true }))
}

export const getIconSrc = (category) => {
  return {
    'smart-controller': '/static/svg/smart_controller.svg',
    swix1: '/static/svg/core1.svg',
    swix2: '/static/svg/core2.svg',
    os2_nat: '/static/svg/os2_nat.svg',
    os2_plus: '/static/svg/os2_plus.svg',
    wrouter: '/static/svg/ap.svg',
    router: '/static/svg/router.svg',
    routerx: '/static/svg/routerx.svg',
    os5: '/static/svg/os5.svg',
    os6: '/static/svg/os6.svg',
    carrier_switch: '/static/svg/carrier_switch.svg',
    viewer: '/static/svg/viewer.svg',
    autopvt: '/static/svg/autopvt.svg',
  }[category]
}



// WEBPACK FOOTER //
// ./src/index.js